import { useEffect, useState } from "react";

const CustomCursor = () => {
    const [pos, setPos] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const move = (e) => {
            setPos({ x: e.clientX, y: e.clientY });
        };
        window.addEventListener("mousemove", move);
        return () => window.removeEventListener("mousemove", move);
    }, []);

    return (
        <div className="hidden lg:flex">
            {/* Center Dot */}
            <div
                className="fixed z-[9999] pointer-events-none
                   w-2 h-2 rounded-full bg-white
                   mix-blend-difference
                   -translate-x-1/2 -translate-y-1/2"
                style={{ left: pos.x, top: pos.y }}
            />

            {/* Outer Ring */}
            <div
                className="fixed z-[9998] pointer-events-none
                   w-8 h-8 rounded-full border border-white
                   mix-blend-difference
                   -translate-x-1/2 -translate-y-1/2"
                style={{ left: pos.x, top: pos.y }}
            />
        </div>
    );
};

export default CustomCursor;
